


























import VueOptions from '@utils/VueOptions'
import VenueNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'
import VenueSpaceBindSelector from '@ui/ResourceBindSelector/VenueSpaceBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'VenueInventoryStep'

  vue:
    props: ['wizard', 'step']

    components: {
      VenueNavbar,
      WizardNavigation,
      VenueSpaceBindSelector,
      Modal,
    }

    data: ->
      missingSpacesModal:
        show: false
        stepName: null

    computed:
      hasSpaces: ->
        @wizard.venueData.space_ids?.length > 0

      displayConfirmModal: ->
        !@hasSpaces

    mounted: ->
      { spaceId, ...query } = @$route.query
      @$router.replace { query }
      @wizard.fetchVenue()

    methods:
      hiEditSpace: (space) ->
        stepName = 'sampling-space-edit' if space.type is 'product_sampling'
        stepName ||= 'onsite-space-edit'
        @wizard.navToStepName stepName
        @$router.replace { query: { ...@$route.query, spaceId: space.id }}

      hiConfirmModal: (stepName) ->
        if !@hasSpaces
          @missingSpacesModal.show = true
          @missingSpacesModal.stepName = stepName
          return

export default VueOptions.vue settings
